
import React, { useContext, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { CommonContext } from "../../../App";
import CancelButton from "../Button/CancelButton";
import SaveButton from "../Button/SaveButton";
import { useTranslation } from "react-i18next";
import googleTransliterate from "../../../utils/googleTransliterate";
import { FaEdit } from "react-icons/fa";
import { ImCross } from "react-icons/im";
import { RiDeleteBin6Fill } from "react-icons/ri";
import api from "../../../services/api";

const emptyForm = { name: "", nameInHindi: "", price: "" };

const AddAreaModal = ({
  onClose,
  onAreaAdded,
  selectedArea,
  onAreaSaved,
  addMultiple = false,
}) => {
  const { branchId } = useContext(CommonContext);
  const { t } = useTranslation();
  const storedLang = JSON.parse(localStorage.getItem("second_language"));
  const language = storedLang?.language || "en";

  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(emptyForm);
  const [stagedAreas, setStagedAreas] = useState([]);
  const [showHindiField, setShowHindiField] = useState(false);
  const [hindiSuggestion, setHindiSuggestion] = useState("");
const [suggestions, setSuggestions] = useState([]);
  //  Track which staged item is being edited (-1 = none)
  const [editingIndex, setEditingIndex] = useState(-1);

  // Prefill when editing existing area
  useEffect(() => {
    if (selectedArea) {
      setFormData({
        name: selectedArea.name || "",
        nameInHindi: selectedArea.name_in_hindi || "",
        price: selectedArea.price || "",
      });
    } else {
      setFormData(emptyForm);
      setStagedAreas([]);
      setEditingIndex(-1);
    }
  }, [selectedArea]);

  // const handleChange = async (e) => {
  //   const { name, value } = e.target;
  //   setFormData((prev) => ({ ...prev, [name]: value }));

  //   if (name === "name") {
  //     setHindiSuggestion(value);
  //     if (language !== "en" && value.trim()) {
  //       try {
  //         const converted = await googleTransliterate(value, language);
  //         setFormData((prev) => ({ ...prev, nameInHindi: converted }));
  //       } catch (err) {
  //         console.error("Transliteration error:", err);
  //       }
  //     } else if (!value.trim()) {
  //       setFormData((prev) => ({ ...prev, nameInHindi: "" }));
  //     }
  //   }
  // };
const handleChange = async (e) => {
  const { name, value } = e.target;

  setFormData((prev) => ({ ...prev, [name]: value }));

  if (name === "name") {
    setHindiSuggestion(value);

    if (language !== "en" && value.trim()) {
      try {
        const result = await googleTransliterate(value, language);

        if (typeof result === "object") {
          setFormData((prev) => ({
            ...prev,
            nameInHindi: result.text,
          }));

          setSuggestions(result.suggestions?.slice(0, 4) || []);
        } else {
          setFormData((prev) => ({
            ...prev,
            nameInHindi: result,
          }));
        }

      } catch (err) {
        console.error("Transliteration error:", err);
      }
    } else {
      setSuggestions([]);
    }
  }
};
  // const handleConvertNameInHindi = async (value) => {
  //   setHindiSuggestion(value);
  //   try {
  //     const converted = await googleTransliterate(value, language);
  //     setFormData((prev) => ({ ...prev, nameInHindi: converted }));
  //   } catch (err) {
  //     console.error("Transliteration error:", err);
  //   }
  // };

  //  Add to staged list OR update existing staged item
  const handleConvertNameInHindi = async (value) => {
  setHindiSuggestion(value);

  try {
    const result = await googleTransliterate(value, language);

    if (typeof result === "object") {
      setFormData((prev) => ({
        ...prev,
        nameInHindi: result.text,
      }));

      setSuggestions(result.suggestions?.slice(0, 3) || []);
    } else {
      setFormData((prev) => ({
        ...prev,
        nameInHindi: result,
      }));
    }

  } catch (err) {
    console.error("Transliteration error:", err);
  }
};
  
  const handleAddMore = () => {
    if (!formData.name.trim() || !formData.price) {
      toast.error("Please fill area name and price");
      return;
    }

    const newItem = {
      name: formData.name.trim(),
      nameInHindi: formData.nameInHindi,
      price: Number(formData.price),
    };

    if (editingIndex >= 0) {
      //  Update staged item
      setStagedAreas((prev) => {
        const updated = [...prev];
        updated[editingIndex] = newItem;
        return updated;
      });
      setEditingIndex(-1);
      toast.success("Area updated in list");
    } else {
      // Add new to staged list
      setStagedAreas((prev) => [...prev, newItem]);
      toast.success("Added to list");
    }

    setFormData(emptyForm);
    setHindiSuggestion("");
  };

  //  Load staged item into form for editing
  const handleEditStaged = (index) => {
    const item = stagedAreas[index];
    setFormData({
      name: item.name,
      nameInHindi: item.nameInHindi || "",
      price: String(item.price),
    });
    setHindiSuggestion(item.name);
    setEditingIndex(index);
  };
  //  Remove staged item
  const handleRemoveStaged = (index) => {
    setStagedAreas((prev) => prev.filter((_, i) => i !== index));
    // If we were editing this item, reset form
    if (editingIndex === index) {
      setFormData(emptyForm);
      setHindiSuggestion("");
      setEditingIndex(-1);
    } else if (editingIndex > index) {
      setEditingIndex((prev) => prev - 1);
    }
  };

  //  Cancel edit mode
  const handleCancelEdit = () => {
    setFormData(emptyForm);
    setHindiSuggestion("");
    setEditingIndex(-1);
  };

  const handleSave = async () => {
    if (!formData.name.trim() || !formData.price) {
      // Allow save if staged list has items and form is empty
      if (stagedAreas.length === 0) {
        toast.error("Please fill area name and price");
        return;
      }
    }

    // Build final list: staged + current form (if filled)
    const currentFormItem = formData.name.trim() && formData.price
      ? [{
          name: formData.name.trim(),
          nameInHindi: formData.nameInHindi,
          price: Number(formData.price),
        }]
      : [];

    // If editing a staged item, update it
    let finalStagedAreas = [...stagedAreas];
    if (editingIndex >= 0 && currentFormItem.length > 0) {
      finalStagedAreas[editingIndex] = currentFormItem[0];
      finalStagedAreas = finalStagedAreas;
    }

    const finalAreas = editingIndex >= 0
      ? finalStagedAreas
      : [...stagedAreas, ...currentFormItem];

    if (finalAreas.length === 0) {
      toast.error("Please add at least one area");
      return;
    }

    try {
      setLoading(true);
      let res;

      if (selectedArea) {
        // Update single existing area
        const r = finalAreas[0];
        res = await api.put(`area/update/${selectedArea.id}`, { ...r, branchId });
        toast.success("Area updated successfully");
        if (onAreaSaved) onAreaSaved();
      } else if (addMultiple) {
        // Bulk create
        res = await api.post(`area/create`, { branchId, areas: finalAreas });
        toast.success(`${finalAreas.length} area${finalAreas.length > 1 ? "s" : ""} added successfully`);
        if (onAreaSaved) onAreaSaved();
      } else {
        const r = finalAreas[0];
        res = await api.post(`area/create`, { ...r, branchId });
        toast.success("Area added successfully");
        if (onAreaSaved) onAreaSaved();
      }

      if (typeof onAreaAdded === "function") {
        const data = res.data?.data;
        onAreaAdded(data);
      }

      onClose();
    } catch (err) {
      console.error("Error saving area:", err);
      toast.error(" error while saving area");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[100]">
      <div className="bg-white rounded-1 shadow-lg p-2 w-[420px]">

        {/* Header */}
        <div className="font-semibold mb-2 text-center bg-theme-headerBg text-theme-color p-1 rounded-1">
          {selectedArea ? t("editArea") : t("addNewAreaAndRate")}
        </div>

        {/*  STAGED LIST — shows above form when items added */}
        {stagedAreas.length > 0 && (
          <div className="mb-2 px-1">
            <div className="text-xs font-medium text-theme-headerBg mb-1 ">
              {t("addedAreas") || "Added Areas"} ({stagedAreas.length})
            </div>
            <div className="flex flex-col gap-1 max-h-32 overflow-y-auto pr-1">
              {stagedAreas.map((item, index) => (
                <div
                  key={index}
                  className={`flex items-center justify-between rounded border px-2 py-1 text-sm transition-all
                    ${editingIndex === index
                      ? "border-theme-headerBg bg-theme-headerBg/10 font-medium"
                      : "border-gray-200 bg-gray-50 hover:bg-gray-100"
                    }`}
                >
                  {/* Left: area info */}
                  <div className="flex items-center gap-2 flex-1 min-w-0">
                    <span className="text-gray-400 text-xs w-4 shrink-0">{index + 1}.</span>
                    <span className="truncate capitalize text-gray-800">
                      {item.name}
                      {language !== "en" && item.nameInHindi && (
                        <span className="text-gray-400 font-normal ml-1 text-xs">({item.nameInHindi})</span>
                      )}
                    </span>
                    <span className="text-gray-500 text-xs shrink-0">₹{item.price}</span>
                  </div>

                  {/* Right: edit + remove */}
                  <div className="flex items-center gap-1 ml-2 shrink-0">
                    {editingIndex === index ? (
                      <span className="text-xs text-theme-headerBg italic mr-1">{t("editing") || "editing..."}</span>
                    ) : (
                      <button
                        type="button"
                        onClick={() => handleEditStaged(index)}
                        className="text-gray-500 hover:text-theme-headerBg transition-colors p-1 rounded"
                        title="Edit this area"
                      >
                        <FaEdit className="text-xs" />
                      </button>
                    )}
                    <button
                      type="button"
                      onClick={() => handleRemoveStaged(index)}
                      className="text-gray-400 hover:text-red-500 transition-colors p-1 rounded"
                      title="Remove this area"
                    >
                      <RiDeleteBin6Fill className="text-xs" />
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Editing banner */}
        {/* {editingIndex >= 0 && (
          <div className="mx-1 mb-2 px-2 py-1 bg-blue-50 border border-blue-200 rounded text-xs text-blue-700 flex items-center justify-between">
            <span>✏️ {t("editing") || "Editing"} area #{editingIndex + 1}: <strong>{stagedAreas[editingIndex]?.name}</strong></span>
            <button
              type="button"
              onClick={handleCancelEdit}
              className="text-blue-500 hover:text-blue-700 underline ml-2"
            >
              {t("cancel") || "Cancel"}
            </button>
          </div>
        )} */}

        {/* Area Name */}
        <div className="mb-2 px-1">
          <label className="block text-sm font-medium mb-1">{t("areaName")}</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            className="w-full border px-2 py-1 rounded outline-none"
            placeholder="Enter area name"
          />
        </div>

        {/* Manual Hindi field */}
        {showHindiField && (
          <div className="mb-2 px-1">
            <label className="block text-sm font-medium mb-1">{t("areaName")}</label>
            <div className="flex">
              <input
                type="text"
                value={hindiSuggestion}
                onChange={(e) => handleConvertNameInHindi(e.target.value)}
                placeholder="Enter name"
                className="border outline-none rounded-s w-full p-1 px-2"
              />
              <div className="border px-2 w-8 cursor-pointer rounded-e bg-white">
                <ImCross className="mt-2 text-theme-createLedgerColor" onClick={() => setShowHindiField(false)} />
              </div>
            </div>
          </div>
        )}

        {/* Hindi/Punjabi translation */}
        {language !== "en" && (
          <div className="mb-2 px-1">
            <label className="block text-sm font-medium mb-1">
              {language === "hi" ? t("translateinHindi") : t("translateinPunjabi")}
            </label>
            <div className="relative  flex ">
              <input
                type="text"
                value={formData.nameInHindi}
                disabled
                placeholder="Area name in Hindi"
                className="border px-2 py-1 rounded-s w-full cursor-not-allowed bg-gray-100"
                onBlur={() => {
  setTimeout(() => setSuggestions([]), 200);
}}
              />
              {suggestions.length > 0 && (
  <div className="absolute left-0 top-full w-full border rounded bg-white shadow mt-1 z-50 max-h-40 overflow-auto">
    {suggestions.map((s, index) => (
      <div
        key={index}
        className="px-2 py-1 hover:bg-gray-200 cursor-pointer"
        onClick={() => {
          setFormData((prev) => ({
            ...prev,
            nameInHindi: s,
          }));
          setSuggestions([]);
        }}
      >
        {s}
      </div>
    ))}
  </div>
)}
              <div className="border px-2 w-8 cursor-pointer rounded-e bg-white">
                <FaEdit onClick={() => setShowHindiField(true)} className="mt-2" />
              </div>
            </div>
          </div>
        )}

        {/* Price */}
        <div className="mb-3 px-1">
          <label className="block text-sm font-medium mb-1">{t("transportationRate")} (₹)</label>
          <input
            type="number"
            name="price"
            value={formData.price}
            onChange={handleChange}
            className="w-full border px-2 py-1 rounded outline-none"
            placeholder="Enter area price"
          />
        </div>

        {/* Buttons */}
        <div className="flex justify-end items-center gap-2 px-1">
          {/* Left: batch count */}
          {/* <div className="text-xs text-gray-400">
            {stagedAreas.length > 0 && `${stagedAreas.length} area${stagedAreas.length > 1 ? "s" : ""} in list`}
          </div> */}

          {/* Right: action buttons */}
          <div className="flex gap-2">
            <CancelButton onClick={onClose} text={t("cancel")} disabled={loading} />

            {/* Add More button — only in create mode with addMultiple */}
            {addMultiple && !selectedArea && (
              <SaveButton
                onClick={handleAddMore}
                text={editingIndex >= 0
                  ? (t("update") || "Update")
                  : (t("addMore") || "Add More")
                }
                disabled={loading}
              />
            )}

            <SaveButton
              onClick={handleSave}
              text={loading
                ? t("procssing")
                : selectedArea
                  ? t("update")
                  : stagedAreas.length > 0
                    ? `${t("saveAll") || "Save All"}`
                    : t("save")
              }
              disabled={loading}
            />
          </div>
        </div>

      </div>
    </div>
  );
};

export default AddAreaModal;